import type { ListBuilderList } from '../../../types';
import { createDefaultCompetitorColumns } from '../columns';
import { ACTIVE_COMPETITORS_RULE } from '../shared';

/**
 * Competitors linked to customers the user owns, as salesperson or
 * alternate. The salesperson rule is locked, so the server resolves Me to the
 * caller (`getEnforcedFilters`) and no one can widen it; managers use the
 * customer team filter on the All tab instead.
 */
export const myAccountsCompetitorsList: ListBuilderList = {
	id: 'default-competitors-my-accounts',
	cacheTTL: 600000,
	name: 'My Accounts',
	type: 'default',
	active: true,
	sortOrder: 1,
	columns: createDefaultCompetitorColumns(),
	description: 'Competitors at the customers you own',
	defaultSortId: 'column-competitor-customers-desc',
	filterRules: {
		competitorStatus: ACTIVE_COMPETITORS_RULE,
		competitorSalespeople: {
			defaultValue: [
				{ id: 'ME', label: 'Me' },
				{ id: 'ME_ALTERNATE', label: 'Me (Alternate)' },
			],
			locked: true,
		},
	},
};
